// This is so Gatsby is happy when building the application and making sure location is
// defined before being used.
export function safelyGetLocationPathname(): string {
  return typeof window !== "undefined" ? window.location.pathname : "/";
}
